import { useState, type FormEvent } from 'react';
import { Button, ErrorNotice, Field } from '@hive/ui';
import { api, errorMessage } from '../api/client';
import { Dialog } from './Dialog';

/** Change your own password (current password required). */
export function PasswordDialog({ onClose }: { onClose(): void }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (next.length < 8) return setError('Use at least 8 characters for the new password.');
    if (next !== repeat) return setError('The two new passwords do not match.');
    setBusy(true);
    setError(null);
    const { error: err, response } = await api.POST('/v1/me/password', { body: { currentPassword: current, newPassword: next } });
    setBusy(false);
    if (response.status === 204) return setDone(true);
    setError(response.status === 403 ? 'Your current password is not right.' : errorMessage(err));
  }

  return (
    <Dialog
      titleId="password-title"
      title="Change your password"
      onClose={onClose}
      width={440}
      footer={
        done ? (
          <Button variant="primary" onClick={onClose}>
            Done
          </Button>
        ) : (
          <>
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="primary" type="submit" form="password-form" disabled={busy}>
              {busy ? 'Saving…' : 'Change password'}
            </Button>
          </>
        )
      }
    >
      {done ? (
        <p className="mc-note mc-note--ok">Password changed. Use the new one next time you sign in.</p>
      ) : (
        <form id="password-form" className="mc-form" onSubmit={submit}>
          {error && <ErrorNotice title={error} />}
          <Field id="pw-current" label="Current password" type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
          <Field id="pw-new" label="New password" type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} required />
          <Field id="pw-repeat" label="New password again" type="password" autoComplete="new-password" value={repeat} onChange={(e) => setRepeat(e.target.value)} required />
        </form>
      )}
    </Dialog>
  );
}
